const placeholders = [
	"A unicorn filled with glitter!",
	"A taco piñata that spills out tiny tacos!",
	"A galaxy-themed piñata!",
	"A robot that spills out gears and candy!",
	"A rainbow piñata with a pot of gold candy!",
];

function removeRequired(element) {
	element.querySelector("span")?.remove();
	element.querySelector("input")?.removeAttribute("required");
}

function suggestClick() {
	const title = document.querySelector("h1#title");
	const name = document.querySelector("label[for='contactFormName']");
	const email = document.querySelector("label[for='contactFormEmail']");
	const message = document.querySelector("label[for='contactFormMessage']");
	const send = document.querySelector("input[type='submit']");
	const isorder = document.querySelector("#isorder");
	const suggestButton = document.querySelector("#suggestbutton");

	if (isorder) isorder.remove();
	if (title) title.innerHTML = "🎉 What's Your Piñata Idea?";
	if (name) removeRequired(name);
	if (email) removeRequired(email);
	if (message) {
		const p = message.querySelector("p");
		if (p) p.innerText = "Share Your Creative Idea! *";
	}
	if (send) send.value = "🎈 Submit Your Idea!";
	if (suggestButton) suggestButton.remove();

	const textarea = message?.querySelector("textarea");
	if (!textarea) return;
	let index = Math.floor(Math.random() * placeholders.length);
	const updatePlaceholder = () => {
		textarea.setAttribute("placeholder", placeholders[index]);
		index = (index + 1) % placeholders.length;
	};
	setInterval(updatePlaceholder, 2000);
	updatePlaceholder();
}

document.addEventListener("DOMContentLoaded", () => {
	const btn = document.querySelector("#suggestbutton");
	if (btn) btn.addEventListener("click", suggestClick);
});
